import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CircularProgress, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import FileStorageComponent from "./FileStorageComponent";
import { FilteredFileStorage, selectFilteredReportHistoryCount } from "../../redux/selectors/history.selector";
import usePagination from "../MySubscriptions/Pagination";
import { reportActions } from "../../redux/actions/report.actions";

export interface FileStorageTableProps {
    userReportHistoryLoading: boolean;
    filteredUserReportHistory:FilteredFileStorage[];
    isAdmin?:boolean;
    isReportShare:boolean;
    setStatusType: (type:string) => void;
    page:number;
    handleChange:(e:any,p:number)=>void;
  }

function FileStorageTable({userReportHistoryLoading,filteredUserReportHistory,isAdmin,isReportShare,setStatusType,page,handleChange}:Readonly<FileStorageTableProps>){
    const dispatch = useDispatch();
    const pageCount = 9;
    const _DATA = usePagination(filteredUserReportHistory, pageCount);
    const [currPage, setCurrPage] = useState(page);
    const listCount = useSelector(selectFilteredReportHistoryCount);
    const handlePrevChange = (e:any, p:number) => {
        console.log(p);
        console.log(page);
        setCurrPage(p);
        _DATA.jump(p);
        };

        const sortByName = () =>{
            setStatusType('');
            dispatch(reportActions.sortReportHistory("nameLowered"));
        }
       
      const sortByRunDate = () =>{
        dispatch(reportActions.sortReportHistory("startDateUTC"));
        setStatusType('');
      }
    
      useEffect(()=>{
        console.log(filteredUserReportHistory);
            _DATA.jump(page);
            setCurrPage(page);

      },[page,filteredUserReportHistory])
    
    return (
                <TableContainer
                        style={{
                            overflow:
                            userReportHistoryLoading || filteredUserReportHistory.length === 0
                                ? "hidden"
                                : "auto",
                            margin:"12px 12px",
                            width:"98%",
                            background:"#FFF"
                        }}
                        >
                        <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow className="table-header">
                                <TableCell align="left" style={{ width: "30%", minWidth: 350 }}>
                                <div
                                    className="sortable"
                                    onClick={() => sortByName()}
                                    title="Sort"
                                >
                                    Report Title
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                        <g id="ArrowDown">
                                                        <path id="Vector" fillRule="evenodd" clipRule="evenodd" d="M16.707 11.2344C16.8944 11.4219 16.9997 11.6762 16.9997 11.9414C16.9997 12.2066 16.8944 12.4609 16.707 12.6484L10.707 18.6484C10.5194 18.8359 10.2651 18.9412 9.99996 18.9412C9.73479 18.9412 9.48049 18.8359 9.29296 18.6484L3.29296 12.6484C3.19745 12.5562 3.12127 12.4458 3.06886 12.3238C3.01645 12.2018 2.98886 12.0706 2.98771 11.9378C2.98655 11.805 3.01186 11.6733 3.06214 11.5505C3.11242 11.4276 3.18667 11.3159 3.28056 11.222C3.37446 11.1281 3.48611 11.0539 3.60901 11.0036C3.7319 10.9533 3.86358 10.928 3.99636 10.9292C4.12914 10.9303 4.26036 10.9579 4.38236 11.0103C4.50437 11.0627 4.61471 11.1389 4.70696 11.2344L8.99996 15.5274V3.94141C8.99996 3.67619 9.10532 3.42184 9.29285 3.2343C9.48039 3.04676 9.73474 2.94141 9.99996 2.94141C10.2652 2.94141 10.5195 3.04676 10.7071 3.2343C10.8946 3.42184 11 3.67619 11 3.94141V15.5274L15.293 11.2344C15.4805 11.0469 15.7348 10.9416 16 10.9416C16.2651 10.9416 16.5194 11.0469 16.707 11.2344Z" fill="#8EA0B6"/>
                                                        </g>
                                                    </svg>
                                </div>
                                </TableCell>
                                <TableCell align="left" style={{ width: "10%", minWidth: 160 }}>
                                <div
                                    className="sortable"
                                    onClick={() => sortByRunDate()}
                                    title="Sort"
                                >
                                    Run Date
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                        <g id="ArrowDown">
                                                        <path id="Vector" fillRule="evenodd" clipRule="evenodd" d="M16.707 11.2344C16.8944 11.4219 16.9997 11.6762 16.9997 11.9414C16.9997 12.2066 16.8944 12.4609 16.707 12.6484L10.707 18.6484C10.5194 18.8359 10.2651 18.9412 9.99996 18.9412C9.73479 18.9412 9.48049 18.8359 9.29296 18.6484L3.29296 12.6484C3.19745 12.5562 3.12127 12.4458 3.06886 12.3238C3.01645 12.2018 2.98886 12.0706 2.98771 11.9378C2.98655 11.805 3.01186 11.6733 3.06214 11.5505C3.11242 11.4276 3.18667 11.3159 3.28056 11.222C3.37446 11.1281 3.48611 11.0539 3.60901 11.0036C3.7319 10.9533 3.86358 10.928 3.99636 10.9292C4.12914 10.9303 4.26036 10.9579 4.38236 11.0103C4.50437 11.0627 4.61471 11.1389 4.70696 11.2344L8.99996 15.5274V3.94141C8.99996 3.67619 9.10532 3.42184 9.29285 3.2343C9.48039 3.04676 9.73474 2.94141 9.99996 2.94141C10.2652 2.94141 10.5195 3.04676 10.7071 3.2343C10.8946 3.42184 11 3.67619 11 3.94141V15.5274L15.293 11.2344C15.4805 11.0469 15.7348 10.9416 16 10.9416C16.2651 10.9416 16.5194 11.0469 16.707 11.2344Z" fill="#8EA0B6"/>
                                                        </g>
                                                    </svg>
                                </div>
                                </TableCell>
                                <TableCell align="left" style={{ width: "10%", minWidth: 100 }}>
                                Report Format
                                </TableCell>
                                <TableCell align="center"
                                style={{
                                    width: "20%",
                                    minWidth: 250,
                                    position: "sticky",
                                    right: 0,
                                }}
                                >
                                Status
                                </TableCell>
                                <TableCell
                                align="center"
                                style={{
                                    width: "5%",
                                    minWidth: 50,
                                    position: "sticky",
                                    right: 0,
                                    background:'#FFF'
                                }}
                                >
                                Action
                                </TableCell>
                            </TableRow>
                            </TableHead>
                        <TableBody>
                            
                            {!userReportHistoryLoading &&_DATA.currentData().map((reportHistory, i: number) => {
                            return (
                                <FileStorageComponent
                                reportHistory={reportHistory}
                                isAdmin={isAdmin}
                                isReportShare={isReportShare}
                                key={reportHistory.userReportHistoryId}
                              />
                            );
                            })}
                        </TableBody>
                    </Table>
                        {/* {!userReportHistoryLoading && filteredUserReportHistory.length === 0 && ( */}
                    
                        {/* )} */}
                        {userReportHistoryLoading && (
                            <div className="spinner" data-testid="loader">
                            <CircularProgress size={30} />
                            </div>
                        )}
                
                        {!userReportHistoryLoading && filteredUserReportHistory.length === 0 && (
                            <div className="no-subscriptions" data-testid="no-subscriptions">
                                 No Files found.
                            </div>
                        )}
                        <div className="footer" data-testid="footer">
                    {filteredUserReportHistory.length<pageCount?<Typography className="page-status">Showing {filteredUserReportHistory.length} Results</Typography>
                        :<Typography className="page-status">Showing {pageCount} Results of {listCount} </Typography>
                    }
                        <Pagination className="pagination"
                        count={listCount?Number(((listCount)/pageCount).toFixed(0)):0}
                        size="large"
                        page={currPage}
                        variant="outlined"
                        shape="rounded"
                        onChange={(e,p)=>p<page+1?handlePrevChange(e,p):handleChange(e,p)}
                        data-testid="page-change"
                        style={{float:'right'}}
                    />
                    </div>
                    
                </TableContainer>
    );
}

export default FileStorageTable